import { array, mixed, string } from 'yup'
import { safify } from '../utils/safify'

export const brandVoiceId = mixed()
  .default(undefined)
  .meta({
    label: 'Select your brand voice',
    autoFill: true,
    featureFlags: {
      brand_kits: false,
    },
  })
  .transform(safify)
export const tone = array()
  .of(string())
  .default([])
  .meta({ hide: true, autoFill: true, featureFlags: { brand_kits: false } })
  .transform(safify)
